import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors (known benign browser issue)
// This error occurs when ResizeObserver can't deliver all notifications in a single animation frame
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver loop') || 
      (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop'))) {
    return;
  }
  originalError.apply(console, args);
};

// Also handle it in window.onerror for the error overlay
const originalOnError = window.onerror;
window.onerror = (message, ...args) => {
  if (message?.includes?.('ResizeObserver loop')) {
    return true; // Prevents the error from showing
  }
  return originalOnError?.(message, ...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
